import { render, staticRenderFns } from "./NoAuthority.vue?vue&type=template&id=6cabc833&scoped=true&"
import script from "./NoAuthority.vue?vue&type=script&lang=js&"
export * from "./NoAuthority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cabc833",
  null
  
)

export default component.exports